import {Injectable} from '@angular/core';

@Injectable()
export class ApiConstant 
{
    public MainUrl: string = 'https://www.phoenixgames.in/';
    // public Server: string = 'http://localhost:1000/';
    // public ServerUrl: string = 'http://localhost/';
    public Server: string = 'https://api.phoenixgames.in:1000/';
    public ServerUrl: string = 'https://api.phoenixgames.in/';
    public ApiUrl: string = 'v1/admin/';
    public ServerWithApiUrl = this.Server + this.ApiUrl;
    public crypto_password: string = 'M46CmAptvVma7OcRw41e6n9VtdLwgaC9';
    public isSecurity : boolean = true;
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/api.constant.ts